export default __webpack_public_path__ + "static/media/suggested-vat-account-10.102b87ff.png";